const state = {
  crmName: ''
}

export default state
